import React from 'react';
import { Img } from '@chakra-ui/react';
import { Global } from '@emotion/react';
import { TTemplate } from '@/helpers/createTemplate';
import {
  LocationNotAllowedContainer,
  CenterWrapper,
} from '../styles/LocationNotAllowed.styles';
import logo from '../../../assets/betprofessor/images/logo.svg';
import Heading from '../components/Heading';
import Body from '../components/Body';

const { REACT_APP_THEME_NAME } = window.BETCLOUD_ENV;

const template: TTemplate = {
  wrapper: <LocationNotAllowedContainer />,
  main: {
    wrapper: <CenterWrapper />,
    logo: (
      <Img
        src={logo}
        alt={REACT_APP_THEME_NAME}
        h={['45px', null, '47px']}
        mt={['80px', null, '0']}
        mb={['2', null, '6']}
      />
    ),
    heading: <Heading />,
    desc: <Body />,
    body: (
      <Global styles={{ body: { background: 'var(--bc-colors-gray-400)' } }} />
    ),
  },
};

export default template;
